import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingState() {

    return (

        <Box
            sx={{
                py: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}
        >

            <CircularProgress />

            <Typography sx={{ mt: 2 }}>

                Loading knowledge repository...

            </Typography>

        </Box>

    );

}